import { createApp } from 'vue';
import { instalarCapturaVue } from '../../src/services/monitoramento';

const apps = import.meta.glob('../../src/widgets/**/App.vue')

export function montarWidgets(raiz = document) {
  const elementos = raiz.querySelectorAll('[data-component]')

  if (elementos.length < 1) return Promise.resolve([]);

  const montagens = []

  elementos.forEach((el) => {
    if (typeof el.dataset.vApp !== 'undefined') return;

    const path = `../../src/${el.dataset.component}/App.vue`

    if (!apps[path]) {
      console.warn("Vue component not found at", path)
      return;
    }

    el.dataset.vApp = 'montando'

    const montagem = apps[path]().then((mod) => {
      let props = {};
      try {
        props = el.dataset.props ? JSON.parse(el.dataset.props) : {};
      } catch (e) {
        console.error(`Erro ao parsear JSON do data-props para o componente ${path}:`, el.dataset.props, e);
      }

      const app = instalarCapturaVue(createApp(mod.default, props))
      app.config.globalProperties.$i18n = window.t
      app.mount(el)
      el.dataset.vApp = 'true'
    }).catch((e) => {
      delete el.dataset.vApp
      console.error(`Erro ao montar o componente ${path}:`, e);
    })

    montagens.push(montagem)
  })

  return Promise.all(montagens)
}

document.addEventListener('DOMContentLoaded', () => montarWidgets())
